export const siteThreatsTiming = [
  { id: 1, name: 'Only in the past and unlikely to return' },
  { id: 2, name: 'In the past but now suspended and likely to return' },
  { id: 3, name: 'Ongoing' },
  { id: 4, name: 'Only in the future' },
  { id: 5, name: 'Unknown' }
]
